<div class="folder-view-container">
  <div class="header-container">
    <div class="left-section">
      <button nbButton outline [nbSpinner]="newEmailspinner" [disabled]="newEmailspinner" status="danger"
        style="font-weight: normal;text-transform: none; height: 38px;" (click)="openModal()">
        <nb-icon icon="file-add-outline"></nb-icon> Nouvel email
      </button>
      <button nbButton outline status="info" style="font-weight: normal; text-transform: none; margin-left: 10px; height: 38px;" (click)="openCreateFolderDialog(folderDialog)">
        <nb-icon icon="folder-add-outline"></nb-icon> Nouveau dossier
      </button>
    </div>
    <app-create-email-from-template
      (templateSelected)="onTemplateSelect($event.id, $event.name, $event.type)"
      #templateModal>
    </app-create-email-from-template>
    <div class="right-section">
      <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange($event)" placeholder="Rechercher par nom" class="search-input">
      <select [(ngModel)]="displayMode" (change)="onDisplayModeChange()" class="form-select select-color">
        <option value="grid">Grille</option>
        <option value="smallGrid">Petite grille</option>
        <option value="list">Liste</option>
      </select>
      <button nbButton status="outline" style="font-weight: normal;text-transform: none;margin-left: 10px;height: 38px;" (click)="onSort()">
        Date de création
        <i [class]="sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
      </button>
    </div>
  </div>
  <!-- Loading State -->
  @if (loading) {
    <div class="loading-container">
      <nb-spinner status="info"></nb-spinner>
      <p>Loading folder contents...</p>
    </div>
  }
  <span class="fil-ariane">
    <h6>
      <div class="breadcrumb-container">
        <div class="breadcrumb-nav">
          <!-- Root "E-mails" link - always present -->
          <strong><a class="breadcrumb-item" [routerLink]="['/pages/generator']">Emails</a></strong>

          <!-- Separator after root item -->
          @if (breadcrumb.length > 0 || currentFolder) {
            <span class="breadcrumb-separator"> / </span>
          }

          <!-- Intermediate breadcrumb items -->
          @for (item of breadcrumb; track item; let i = $index; let last = $last) {
            <!-- Parent folders (green) -->
            @if (!last) {
              <a class="breadcrumb-item" [routerLink]="['/pages/generator/folder', item.id]">{{ item.name }}</a>
              <span class="breadcrumb-separator"> / </span>
            }
            <!-- Last item in breadcrumb (current folder - black) -->
            @if (last) {
              <a class="breadcrumb-item active" [routerLink]="['/pages/generator/folder', item.id]">{{ item.name }}</a>
            }
          }

        </div>
      </div>
    </h6>
  </span>
  <!-- Folder Contents -->
  @if (!loading) {
    <div class="folder-contents">
      <!-- Emails Section -->
      @if (emails.length > 0 || folders.length > 0 || isSearching) {
        <div class="emails">
          @if (isSearching) {
            <h6 class="search-section-title">
              <nb-icon icon="folder-outline"></nb-icon>
              <strong>Dans ce dossier</strong>
              <span class="search-result-count">— {{ filteredEmails.length + filteredFolders.length }} résultat(s)</span>
            </h6>
          }
          @if (folders.length > 0) {
            <div class="folder-list">
              @for (folder of filteredFolders; track folder) {
                <div class="folder-item">
                  <svg class="folder-svg" viewBox="3 4 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" (dragover)="onDragOver($event)" (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event, folder)" (click)="navigateToFolder(folder.id)">
                    <!-- Folder outline -->
                    <path d="M3 8.2C3 7.07989 3 6.51984 3.21799 6.09202C3.40973 5.71569 3.71569 5.40973 4.09202 5.21799C4.51984 5 5.0799 5 6.2 5H9.67452C10.1637 5 10.4083 5 10.6385 5.05526C10.8425 5.10425 11.0376 5.18506 11.2166 5.29472C11.4184 5.4184 11.5914 5.59135 11.9373 5.93726L12.0627 6.06274C12.4086 6.40865 12.5816 6.5816 12.7834 6.70528C12.9624 6.81494 13.1575 6.89575 13.3615 6.94474C13.5917 7 13.8363 7 14.3255 7H17.8C18.9201 7 19.4802 7 19.908 7.21799C20.2843 7.40973 20.5903 7.71569 20.782 8.09202C21 8.51984 21 9.0799 21 10.2V15.8C21 16.9201 21 17.4802 20.782 17.908C20.5903 18.2843 20.2843 18.5903 19.908 18.782C19.4802 19 18.9201 19 17.8 19H6.2C5.07989 19 4.51984 19 4.09202 18.782C3.71569 18.5903 3.40973 18.2843 3.21799 17.908C3 17.4802 3 16.9201 3 15.8V8.2Z" stroke="#e9ecef" stroke-width="0.2" stroke-linecap="round" stroke-linejoin="round" fill="white"/>
                    <!-- Folder name text -->
                    <text x="12" y="12" font-size="1.5" text-anchor="middle" fill="#000000">{{ folder?.name || 'Nouveau dossier' }}</text>
                    <!-- Circle with count -->
                    <circle cx="12" cy="15" r="1.2" fill="#f0f0f0" stroke="#d0d0d0" stroke-width="0.1"/>
                    <text x="12" y="15.4" font-size="1" text-anchor="middle" fill="#666666">{{ folder.email_count || 0 }}</text> <!-- à changer -->
                  </svg>
                  <!-- Menu toggle button positioned directly on the SVG -->
                  <button nbButton ghost size="small" class="menu-toggle" (click)="$event.stopPropagation(); toggleFolderMenu($event, folder)">
                    <i class="bi bi-three-dots"></i>
                  </button>
                  <!-- Folder context menu -->
                  @if (showFolderMenu && currentFolder === folder) {
                    <div class="menu-options folder-menu-options" (click)="$event.stopPropagation()">
                      <a class="dropdown-item" (click)="navigateToFolder(folder.id)">
                        <nb-icon icon="eye-outline"></nb-icon> Ouvrir
                      </a>
                      <a class="dropdown-item" (click)="duplicateFolder(folder)">
                        <nb-icon icon="copy-outline"></nb-icon> Dupliquer
                      </a>
                      <a class="dropdown-item" (click)="openEditFolderDialog(folder, folderDialog)">
                        <nb-icon icon="edit-outline"></nb-icon> Renommer
                      </a>
                      <hr>
                        <a class="dropdown-item" (click)="openMoveFolderDialog(folder, moveFolderDialog)">
                          <nb-icon icon="move-outline"></nb-icon> Déplacer vers
                        </a>
                        <hr>
                          <a class="dropdown-item delete-option" (click)="confirmDeleteFolder(folder, deleteFolderDialog)">
                            <nb-icon icon="trash-2-outline"></nb-icon> Supprimer
                          </a>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if (!isSearching || filteredEmails.length > 0) {
              <div class="campaign-grid" [ngClass]="{'small-grid': displayMode === 'smallGrid', 'list-view': displayMode === 'list'}">
                <div class="campaign-menu">
                  <div class="campaign-item-details">
                    <div class="campaign-title"><strong>Campagne</strong></div>
                    <div class="campaign-title"><strong>Date</strong></div>
                    <div class="campaign-title"><strong>Objet</strong></div>
                  </div>
                </div>
                @for (email of filteredEmails; track email) {
                  <ng-container *ngTemplateOutlet="emailCard; context: { $implicit: email, showFolder: false }"></ng-container>
                }
              </div>
              }
              <!-- Global search: matching emails located outside the current folder -->
              @if (isSearching) {
                <h6 class="search-section-title">
                  <nb-icon icon="search-outline"></nb-icon>
                  <strong>Dans les autres dossiers</strong>
                  @if (!loadingGlobalSearch) {
                    <span class="search-result-count">— {{ otherEmails.length }} résultat(s)</span>
                  }
                </h6>
                @if (loadingGlobalSearch) {
                  <div class="folder-loading">
                    <nb-spinner size="small"></nb-spinner> Recherche en cours...
                  </div>
                }
                @if (otherEmails.length > 0) {
                <div class="campaign-grid" [ngClass]="{'small-grid': displayMode === 'smallGrid', 'list-view': displayMode === 'list'}">
                  <div class="campaign-menu">
                    <div class="campaign-item-details">
                      <div class="campaign-title"><strong>Campagne</strong></div>
                      <div class="campaign-title"><strong>Date</strong></div>
                      <div class="campaign-title"><strong>Objet</strong></div>
                      <div class="campaign-title campaign-folder-header"><strong>Dossier</strong></div>
                    </div>
                  </div>
                  @for (email of otherEmails; track email) {
                    <ng-container *ngTemplateOutlet="emailCard; context: { $implicit: email, showFolder: true }"></ng-container>
                  }
                </div>
                }
                @if (!loadingGlobalSearch && otherEmails.length === 0 && filteredEmails.length === 0 && filteredFolders.length === 0) {
                  <div class="empty-search-state">
                    <nb-icon icon="search-outline"></nb-icon>
                    <p>Aucun email ne correspond à "{{ searchTerm }}"</p>
                  </div>
                }
              }
                </div>
              }
              <!-- Empty State -->
              @if (folders.length === 0 && emails.length === 0 && !isSearching) {
                <div class="empty-state">
                  <nb-icon icon="folder-outline" status="info"></nb-icon>
                  <p>Ce dossier est vide.</p>
                </div>
              }
            </div>
          }

          <!-- Email card, shared by the current folder list and the global search results -->
          <ng-template #emailCard let-email let-showFolder="showFolder">
            <div class="campaign-item" draggable="true" (dragstart)="onDragStart($event, email)" (dragend)="onDragEnd($event)" (click)="editEmail(email)">
              @if (email.preview_img_url) {
                <div class="image-container">
                  <img [src]="email.preview_img_url! + (email.preview_img_url!.includes('?') ? '&' : '?') + 'v=' + email.heure" alt="{{email.name}}" class="campaign-image" [class.loading-blur]="loadingPreviews.has(email.id)">
                  @if (loadingPreviews.has(email.id)) {
                    <div class="loading-overlay">
                      <nb-spinner status="info" size="medium"></nb-spinner>
                    </div>
                  }
                  @if (email.campaign_id) {
                    <span class="automation-badge" title="Email Dynamic">
                      <nb-icon icon="flash-outline"></nb-icon> Dynamic
                    </span>
                  }
                  @if (showFolder && getFolderName(email)) {
                    <span class="folder-badge" [title]="getFolderPath(email)">
                      <nb-icon icon="folder-outline"></nb-icon> {{ getFolderName(email) }}
                    </span>
                  }
                </div>
              } @else {
                <div class="image-container">
                  <div class="campaign-image placeholder" [class.loading-blur]="loadingPreviews.has(email.id)"></div>
                  @if (loadingPreviews.has(email.id)) {
                    <div class="loading-overlay">
                      <nb-spinner status="info" size="medium"></nb-spinner>
                    </div>
                  }
                  @if (email.campaign_id) {
                    <span class="automation-badge" title="Email Dynamic">
                      <nb-icon icon="flash-outline"></nb-icon> Dynamic
                    </span>
                  }
                  @if (showFolder && getFolderName(email)) {
                    <span class="folder-badge" [title]="getFolderPath(email)">
                      <nb-icon icon="folder-outline"></nb-icon> {{ getFolderName(email) }}
                    </span>
                  }
                </div>
              }
              <div class="campaign-item-details">
                <div class="campaign-title" title="{{ email.name }}">{{ email.name }}</div>
                <div class="campaign-date">{{ email.heure | date: 'medium' }}</div>
                <div class="campaign-objet">{{ email.object }}</div>
                @if (showFolder) {
                  <div class="campaign-folder" [title]="getFolderPath(email)">
                    <nb-icon icon="folder-outline"></nb-icon> {{ getFolderName(email) }}
                  </div>
                }
              </div>
              <div class="campaign-item-info">
                <button nbButton class="menu-button" (click)="toggleEmailMenu($event, email)">
                  <i class="bi bi-three-dots"></i>
                </button>
                @if (showMenu && currentEmail === email) {
                  <div class="menu-options" (click)="$event.stopPropagation()">
                    <a class="dropdown-item" (click)="editEmail(email)">
                      <nb-icon icon="edit-outline"></nb-icon> Éditer
                    </a>
                    <button class="dropdown-item" (click)="duplicateEmail(email)">
                      <nb-icon icon="copy-outline"></nb-icon> Dupliquer
                    </button>
                    @if (showDynamic$ | async) {
                      <button
                        class="dropdown-item"
                        (click)="openDynamicChoiceDialog(email)">
                        <nb-icon icon="flash"></nb-icon>
                        Dynamic
                      </button>
                    }
                    <button class="dropdown-item" (click)="getLangageCode(languageDialog)">
                      <i class="bi bi-translate"></i> Traduire
                    </button>
                    @if (showInter$ | async) {
                      <button class="dropdown-item" (click)="createInterEmail(email)">
                        <i class="bi bi-globe"></i> Version internationale
                      </button>
                    }
                    <hr>
                      <button class="dropdown-item" (click)="openMoveEmailDialog(email, moveEmailDialog)">
                        <nb-icon icon="move-outline"></nb-icon> Déplacer vers
                      </button>
                      <hr>
                        <button class="dropdown-item delete-option" (click)="confirmDeleteEmail(email)">
                          <nb-icon icon="trash-2-outline"></nb-icon> Supprimer
                        </button>
                      </div>
                    }
                  </div>
                </div>
          </ng-template>

          <!-- Dialog Templates -->
          <ng-template #folderDialog let-data let-ref="dialogRef">
            <nb-card>
              <nb-card-header>
                {{ selectedFolder ? 'Modifier le dossier' : 'Créer un dossier' }}
              </nb-card-header>
              <nb-card-body>
                <input nbInput fullWidth placeholder="Nom du dossier" [(ngModel)]="newFolderName">
              </nb-card-body>
              <nb-card-footer class="folder-dialog-footer">
                <button nbButton status="info"
                  (click)="selectedFolder ? updateFolder(ref) : createFolder(ref)">
                  Enregistrer
                </button>
                <button nbButton status="basic" (click)="ref.close()">Annuler</button>
              </nb-card-footer>
            </nb-card>
          </ng-template>

          <ng-template #deleteFolderDialog let-ref="dialogRef">
            <nb-card>
              <nb-card-header>Supprimer le dossier</nb-card-header>
              <nb-card-body>
                Êtes-vous sûr de vouloir supprimer le dossier "<strong>{{ selectedFolder?.name }}</strong>" ?<br>
                <strong>TOUS</strong> les emails et dossiers à l'intérieur seront également supprimés.
              </nb-card-body>
              <nb-card-footer class="dialog-footer">
                <button nbButton status="danger" (click)="deleteFolder(ref)">Supprimer</button>
                <button nbButton status="basic" (click)="ref.close()">Annuler</button>
              </nb-card-footer>
            </nb-card>
          </ng-template>

          <ng-template #moveFolderDialog let-ref="dialogRef">
            <nb-card>
              <nb-card-header>Déplacer le dossier</nb-card-header>
              <nb-card-body class="move-dialog-body">
                <app-folder-tree-select
                  [folders]="allFolders"
                  [selectedFolderId]="destinationFolderId"
                  [disabledFolderIds]="invalidDestinationIds"
                  (folderSelected)="destinationFolderId = $event">
                </app-folder-tree-select>
              </nb-card-body>
              <nb-card-footer class="dialog-footer">
                <button nbButton status="info"
                [disabled]="destinationFolderId === selectedFolder?.id || 
                          destinationFolderId === selectedFolder?.parent_id ||
                          invalidDestinationIds.includes(destinationFolderId!)"
                (click)="moveFolder(destinationFolderId, ref)">Déplacer</button>
                <button nbButton status="basic" class="mr-2" (click)="ref.close()">Annuler</button>
              </nb-card-footer>
            </nb-card>
          </ng-template>

          <ng-template #moveEmailDialog let-ref="dialogRef">
            <nb-card>
              <nb-card-header>Déplacer l'email</nb-card-header>
              <nb-card-body class="move-dialog-body">
                <app-folder-tree-select
                  [folders]="allFolders"
                  [selectedFolderId]="destinationFolderId"
                  (folderSelected)="destinationFolderId = $event">
                </app-folder-tree-select>
              </nb-card-body>
              <nb-card-footer class="dialog-footer">
                <button nbButton status="info"
                [disabled]="destinationFolderId === currentEmail?.folder_id || 
                          destinationFolderId === currentEmail?.parent_id"
                (click)="moveEmailToFolder(destinationFolderId, ref)">Déplacer</button>
                <button nbButton status="basic" class="mr-2" (click)="ref.close()">Annuler</button>
              </nb-card-footer>
            </nb-card>
          </ng-template>

          <ng-template #deleteEmailDialog let-ref="dialogRef">
            <nb-card>
              <nb-card-body>Êtes-vous sûr de vouloir supprimer cet email ?</nb-card-body>
              <nb-card-footer>
                <div class="row">
                  <div class="col text-center">
                    <button nbButton status="success" (click)="deleteEmail(currentEmail, ref)">Oui</button>
                  </div>
                  <div class="col text-center">
                    <button nbButton status="danger" (click)="ref.close()">Non</button>
                  </div>
                </div>
              </nb-card-footer>
            </nb-card>
          </ng-template>

          <ng-template #languageDialog let-ref="dialogRef">
            <nb-card>
              <nb-card-header>Choisissez la langue de traduction:</nb-card-header>
              <nb-card-body>
                <ul class="no-bullets three-per-row">
                  @for (lang of languageList; track lang) {
                    <li>
                      <button nbButton outline status="info" size="small" (click)="selectLanguage(currentEmail, lang.code, ref)">{{ lang.text }}</button>
                    </li>
                  }
                </ul>
              </nb-card-body>
            </nb-card>
          </ng-template>

          <ng-template #dialogErrorDeletingFolder let-data let-ref="dialogRef">
            <nb-card>
              <nb-card-body class="text-center">{{ errorMessage }}</nb-card-body>
              <nb-card-footer>
                <div class="row">
                  <div class="col text-center">
                    <button nbButton status="danger" (click)="ref.close()">OK</button>
                  </div>
                </div>
              </nb-card-footer>
            </nb-card>
          </ng-template>

          <ng-template #dialogSuccessDeletingFolder let-data let-ref="dialogRef">
            <nb-card>
              <nb-card-body class="text-center">{{ successMessage }}</nb-card-body>
              <nb-card-footer>
                <div class="row">
                  <div class="col text-center">
                    <button nbButton status="success" (click)="ref.close()">OK</button>
                  </div>
                </div>
              </nb-card-footer>
            </nb-card>
          </ng-template>

          <ng-template #dialogChoice let-data let-ref="dialogRef">
            <nb-card>
              <nb-card-body>Quel type d'email dynamique souhaitez-vous générer ?</nb-card-body>
              <nb-card-footer>
                <div class="row">
                  <div class="col text-center">
                    <button nbButton status="info" size="small" (click)="onDynamicTypeSelected(ref, data.email, false)">Liste de produits</button>
                  </div>
                  <div class="col text-center">
                    <button nbButton status="info" size="small" (click)="onDynamicTypeSelected(ref, data.email, true)">Catégorie complète</button>
                  </div>
                  <div class="col text-center">
                    <button nbButton status="danger" size="small" (click)="ref.close()">Annuler</button>
                  </div>
                </div>
              </nb-card-footer>
            </nb-card>
          </ng-template>

        </div>